/* ANNA BRANDEJS DE — core (fallback, cart, pdp) */
(function(){
  "use strict";
  window.abimg = function(el){
    el.onerror=null; var w=el.parentNode; if(!w) return;
    el.style.display="none";
    if(!w.querySelector(".imgph")){
      var d=document.createElement("div"); d.className="imgph";
      d.textContent=el.getAttribute("alt")||"ANNA BRANDEJS"; w.appendChild(d);
    }
  };
  document.addEventListener("click",function(e){
    var t=e.target.closest("[data-menu-toggle]");
    if(t){ var n=document.querySelector(".catnav"); if(n) n.classList.toggle("open"); }
  });
  var toast;
  function showToast(msg){
    if(!toast){ toast=document.createElement("div"); toast.className="toast"; document.body.appendChild(toast); }
    toast.textContent=msg; toast.classList.add("show");
    clearTimeout(toast._t); toast._t=setTimeout(function(){toast.classList.remove("show");},2200);
  }
  function refreshCart(){
    fetch("/cart.js").then(function(r){return r.json();}).then(function(c){
      document.querySelectorAll("[data-cart-count]").forEach(function(el){ el.textContent=c.item_count; });
    }).catch(function(){});
  }
  refreshCart();
  document.addEventListener("click",function(e){
    var b=e.target.closest("[data-add]");
    if(!b) return;
    e.preventDefault();
    var id=b.getAttribute("data-add"); if(!id) return;
    var qtyEl=document.getElementById("pdp-qty");
    var qty=qtyEl?parseInt(qtyEl.value||"1",10):1;
    b.disabled=true; var old=b.textContent; b.textContent="…";
    fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({id:id,quantity:qty})})
      .then(function(r){return r.json();})
      .then(function(){ refreshCart(); showToast("Zum Warenkorb hinzugefügt"); b.disabled=false; b.textContent=old; })
      .catch(function(){ b.disabled=false; b.textContent=old; window.location="/cart"; });
  });
  document.addEventListener("submit",function(e){
    var f=e.target.closest("[data-product-form]");
    if(!f) return;
    e.preventDefault();
    var fd=new FormData(f);
    var btn=f.querySelector("[type=submit]"); var old=btn?btn.textContent:"";
    if(btn){ btn.disabled=true; btn.textContent="…"; }
    fetch("/cart/add.js",{method:"POST",body:fd})
      .then(function(r){return r.json();})
      .then(function(){ refreshCart(); showToast("Zum Warenkorb hinzugefügt"); if(btn){btn.disabled=false;btn.textContent=old;} })
      .catch(function(){ if(btn){btn.disabled=false;btn.textContent=old;} f.submit(); });
  });
  document.addEventListener("click",function(e){
    var q=e.target.closest("[data-qty]");
    if(q){ var inp=document.getElementById("pdp-qty"); if(inp){ var v=parseInt(inp.value||"1",10);
      v += (q.getAttribute("data-qty")==="up"?1:-1); if(v<1)v=1; inp.value=v; } }
    var th=e.target.closest("[data-thumb]");
    if(th){ var main=document.getElementById("pdp-main"); if(main){ main.src=th.getAttribute("data-thumb"); }
      document.querySelectorAll("[data-thumb]").forEach(function(x){x.classList.remove("active");}); th.classList.add("active"); }
  });
})();
